<template>
  <div class="reward-page">
    <div class="reward-page__header">
      <header-pane colorType="light" :pageTitle="$tc('RewardPage.title')" />
    </div>
    <div class="reward-page__pane">
      <reward-pane />
    </div>
    <div class="reward-page__navigation">
      <global-navigation-pane />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import RewardPane from '@/components/RewardPage/RewardPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import useRewards from '@/store/hook/videoPlatformContents/useRewards'

export default defineComponent({
  name: 'RewardPage',
  components: { GlobalNavigationPane, RewardPane, HeaderPane },
  setup() {
    const { clearRewards } = useRewards()

    onUnmounted(() => {
      clearRewards()
    })
  },
})
</script>

<style scoped lang="scss">
.reward-page {
  display: flex;
  flex-direction: column;
  height: var(--screen-height);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: $gray1;

  &__header,
  &__navigation {
    flex-shrink: 0;
  }

  &__pane {
    flex-grow: 1;
    overflow-y: auto;
  }
}
</style>
